/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { MouseEventHandler, useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Button, Form } from 'react-bootstrap';
import Rnd from './rnd';
import './imageView.scss';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/sectiondeleteIcon.svg';
import { ReactComponent as AddIcon } from '../../../assets/icons/cirlcedPlus.svg';
import LoreeInteractiveEditor from '../../editor/loreeInteractiveEditor';
import Tooltip from '../../utils/tooltip';
import { CONSTANTS } from '../../editor/editorUtilityFunctions/constants';
import { LoreeInteractiveEditorDashboardContentType } from '../../editor/editorUtilityFunctions/lintEditorType';
import { ReactComponent as Collapse } from '../../../assets/icons/collapse.svg';

interface AreaViewComponent {
  type: string;
  setScreenType: Function;
  label: {
    value: string;
    setLabel: Function;
  };
  text: {
    value: string;
    setText: Function;
  };
  setDimension: Function;
  parameters: any;
  fontSize: string;
  icons: {
    status: boolean;
    setStatus: Function;
  };
  dropZone: {
    activeIndex: number;
    setActiveIndex: Function;
  };
  setImageDimension: Function;
  errorHandler: {
    error: any;
    setError: Function;
  };
  editorConfig: LoreeInteractiveEditorDashboardContentType;
  addDropZone: Function;
  updateActiveDropZone: Function;
  setIsDeleted: MouseEventHandler;
  Editor: {
    hideEditor: boolean;
    setHideEditor: Function;
  };
  setParameters: Function;
  errorOnCurrentZone: {
    duplicateLabelError: boolean;
    duplicateTextError: boolean;
    setDuplicateLabelError: Function;
    setDuplicateTextError: Function;
  };
  validateUniqueLabelAndText: Function;
}

const ImageViewComponent = (props: AreaViewComponent) => {
  const {
    type,
    parameters,
    fontSize,
    setScreenType,
    label,
    text,
    setDimension,
    icons,
    dropZone,
    setImageDimension,
    errorHandler,
    editorConfig,
    addDropZone,
    updateActiveDropZone,
    setIsDeleted,
    Editor,
    setParameters,
    errorOnCurrentZone,
    validateUniqueLabelAndText,
  } = props;
  const [backgroundImage, setBackgroundImage] = useState<HTMLImageElement>();
  const [imageWidthAndHeight, setImageWidthAndHeight] = useState<{
    width: string;
    height: string;
  }>();

  useEffect(() => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = parameters.background;
    const img = wrapper.getElementsByTagName('img')[0];
    setBackgroundImage(img);
    const tempImg = new Image();
    tempImg.src = img.src;

    tempImg.onload = () => {
      if (isSvg || !tempImg.naturalWidth) {
        setImageWidthAndHeight({ width: '100%', height: '100%' });
      } else {
        setImageWidthAndHeight({
          width: `${tempImg.naturalWidth}px`,
          height: `${tempImg.naturalHeight}px`,
        });
      }
    };
    parameters.dropZone.forEach((element: any) => {
      migrateHotspot(element);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parameters.background]);

  const handleText = (value: string) => {
    text.setText(value);

    const updated = parameters.dropZone.map((z: any) =>
      z.id === dropZone.activeIndex
        ? {
            ...z,
            data: {
              ...z.data,
              text: value,
            },
          }
        : z,
    );

    setParameters((prev: any) => ({
      ...prev,
      dropZone: updated,
    }));
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;
    const hasText = tempDiv.textContent && tempDiv.textContent.trim() !== '';
    errorOnCurrentZone.setDuplicateTextError(false);
    if (errorIsPresent(dropZone.activeIndex) && hasText) {
      const updatedErrors = errorHandler.error.filter((i: number) => i !== dropZone.activeIndex);
      errorHandler.setError(updatedErrors);
    }
  };

  const migrateHotspot = (element: any) => {
    const image = document.getElementById('dndImage')?.getBoundingClientRect();
    if (!image) return;
    const { imgWidth, imgHeight, width, height, x, y } = element.data;
    if (!imgWidth || !imgHeight) return;
    if (image?.width === imgWidth && image?.height === imgHeight) {
      return;
    } else {
      const scaleX = image?.width / imgWidth;
      const scaleY = image?.height / imgHeight;

      const obj = {
        x: x * scaleX,
        y: y * scaleY,
        w: width,
        h: height,
        imgWidth: image?.width,
        imgHeight: image?.height,
      };
      setDimension(obj, element.id);
    }
  };
  const errorIsPresent = (id: number) => {
    return errorHandler.error.includes(id);
  };
  const isHavedropZone =
    parameters.dropZone.length > 0 && !Editor.hideEditor && Number(dropZone.activeIndex) >= 0;

  const isSvg = backgroundImage?.src?.split('?')[0].endsWith('.svg');

  return (
    <div className={`editor-modal  ${isHavedropZone ? 'isHotspot' : ''}`}>
      <div
        className='d-flex flex-row'
        style={{
          width: isHavedropZone ? '60%' : '100%',
        }}
      >
        <div className='button-wrapper imagemodal'>
          <Button
            size='sm'
            onClick={(e) => {
              const isValid = validateUniqueLabelAndText(
                label.value,
                text.value,
                dropZone.activeIndex,
              );

              if (!isValid) {
                return;
              }
              Editor.setHideEditor(false);
              const emptyData = {
                label: '',
                text: '<p></p>',
              };
              addDropZone(emptyData);
              setImageDimension(document.getElementById('dndImage')?.getBoundingClientRect());
              setScreenType('editDetails');
            }}
            className='delete-icon mb-3 close-btn Add-btn'
          >
            <Tooltip info='Add'>
              <AddIcon />
            </Tooltip>
          </Button>
          <Button
            size='sm'
            onClick={setIsDeleted}
            className={`delete-icon my-3 close-btn delete-btn ${icons.status ? 'disabled' : ''}`}
            disabled={icons.status}
          >
            <Tooltip info='Delete'>
              <DeleteIcon />
            </Tooltip>
          </Button>
        </div>
        <div
          className='image-container'
          style={{
            width: '100%',
            border: '1px solid #E9E9E9',
            borderRadius: '16px',
            overflow: 'scroll',
            padding: '16px',
            margin: '16px',
          }}
        >
          <div
            className='boundry centered-div'
            id='dndImage'
            style={{
              ...(isSvg ? {} : { width: imageWidthAndHeight?.width }),
              height: 'auto',
              maxWidth: '892px',
              backgroundImage: `url('${backgroundImage?.src}')`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
            }}
          >
            {parameters.dropZone?.map((data: any, idx: number) => {
              return (
                <Rnd
                  key={data.id}
                  prop={data}
                  setActiveZone={(index: number) => {
                    const isValid = validateUniqueLabelAndText(
                      label.value,
                      text.value,
                      dropZone.activeIndex,
                    );
                    if (!isValid) {
                      return;
                    }
                    dropZone.setActiveIndex(index);
                    updateActiveDropZone(index);
                    icons.setStatus(false);
                    const selected = parameters.dropZone.find((z: any) => z.id === index);

                    const newText = selected?.data.text ?? '';
                    text.setText(newText);
                    Editor.setHideEditor(false);
                  }}
                  dimensions={setDimension}
                  type={type}
                  size={fontSize}
                  image={backgroundImage}
                  activeIndex={dropZone.activeIndex}
                  setScreenType={setScreenType}
                  isHasError={errorIsPresent(data.id)}
                >
                  <>
                    {type === 'DragandDrop' ? (
                      <h4
                        key={data.id}
                        className={`rnd-label ${errorIsPresent(data.id) ? 'd-none' : ''} ${
                          data.id === dropZone.activeIndex ? 'active' : ''
                        }`}
                      >
                        {data.data.label}
                      </h4>
                    ) : (
                      <></>
                    )}
                    {errorIsPresent(data.id) && (
                      <span
                        style={{
                          position: 'absolute',
                          top: '-15px',
                          right: '-8px',
                          width: Number(fontSize) > 12 ? '10px' : '16px',
                          height: Number(fontSize) > 12 ? '10px' : '16px',
                        }}
                      >
                        <svg
                          width='100%'
                          height='100%'
                          viewBox='0 0 18 18'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M8.57129 0C13.3048 0.000129223 17.1424 3.83685 17.1426 8.57031C17.1426 13.304 13.3049 17.1415 8.57129 17.1416C3.83755 17.1416 0 13.304 0 8.57031C0.000226259 3.83677 3.83769 0 8.57129 0ZM8.57129 10.7139C7.97957 10.7139 7.5 11.1934 7.5 11.7852C7.5 12.3769 7.97957 12.8564 8.57129 12.8564C9.16299 12.8564 9.64257 12.3769 9.64258 11.7852C9.64258 11.1934 9.16299 10.7139 8.57129 10.7139ZM8.56934 4.28516C7.99583 4.28531 7.54742 4.78086 7.60449 5.35156L7.98047 9.10938C8.01074 9.41186 8.26536 9.64244 8.56934 9.64258C8.87341 9.64258 9.1279 9.41193 9.1582 9.10938L9.53418 5.35156C9.59126 4.78077 9.14297 4.28516 8.56934 4.28516Z'
                            fill='#C53330'
                          />
                        </svg>
                      </span>
                    )}
                  </>
                </Rnd>
              );
            })}
            {ReactHtmlParser(parameters.background)}
          </div>
        </div>
      </div>
      {parameters.dropZone.length > 0 &&
        !Editor.hideEditor &&
        Number(dropZone.activeIndex) >= 0 && (
          <div className='editor'>
            <Collapse
              onClick={() => {
                dropZone.setActiveIndex(-1);
                Editor.setHideEditor(true);
                icons.setStatus(true);
              }}
              style={{
                position: 'absolute',
                top: '10px',
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                fontSize: '18px',
                fontWeight: 'bold',
                right: '39%',
              }}
            />
            <Form.Group className='ps-3 pe-3 pt-2'>
              <Form.Label className='option_section'>Label *</Form.Label>
              <Form.Control
                className='lablelInput'
                type='text'
                value={label.value}
                onChange={(event) => {
                  const value = event.target.value;
                  label.setLabel(value);
                  errorOnCurrentZone.setDuplicateLabelError(false);
                  const updated = parameters.dropZone.map((z: any) =>
                    z.id === dropZone.activeIndex
                      ? {
                          ...z,
                          data: {
                            ...z.data,
                            label: value,
                          },
                        }
                      : z,
                  );

                  setParameters((prev: any) => ({
                    ...prev,
                    dropZone: updated,
                  }));
                  if (errorIsPresent(dropZone.activeIndex) && value.trim() !== '') {
                    const updatedErrors = errorHandler.error.filter(
                      (i: number) => i !== dropZone.activeIndex,
                    );
                    errorHandler.setError(updatedErrors);
                  }
                }}
              />
              {errorOnCurrentZone.duplicateLabelError && (
                <Form.Text className='text-danger'>Label already exists.</Form.Text>
              )}
            </Form.Group>
            <Form.Group className=' sectionBody'>
              <Form.Label className='option_section'>Text *</Form.Label>
              <LoreeInteractiveEditor
                key={`${dropZone.activeIndex}-${parameters.dropZone[dropZone.activeIndex]?.id}`}
                initialValue={text.value ?? CONSTANTS.LOREE_EDITOR_EMPTY_CONTENT}
                editorConfig={editorConfig}
                updateEditorContent={(value: string) => {
                  handleText(value);
                }}
                type={type}
                titleValue={`${label.value.trim() === '' ? 'Label' : label.value.trim()}`}
                selection=''
                subSelection=''
              />
            </Form.Group>
            {errorOnCurrentZone.duplicateTextError && (
              <Form.Text className='text-danger ps-2'>Text already exists.</Form.Text>
            )}
          </div>
        )}
    </div>
  );
};

export default ImageViewComponent;
